// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1169":"d2e8fe036a51deb4","4825":"ff15ddd63344e8f8"}[chunkId] + ".js";
};